import React from 'react';
import { useDispatch } from 'react-redux';
import { setNewAgentModal } from '../../store/Agent';
import './index.css';

const EmptyAgentState = () => {
  const dispatch = useDispatch();

  const handleCreateAgent = () => {
    dispatch(setNewAgentModal(true));
  };

  return (
    <div className='empty-agent-state'>
      <div className='empty-state-content'>
        <div className='empty-state-header'>
          <div className='img-box'>
            <img alt="Welcome" src="https://assets-seleagent.s3.us-east-2.amazonaws.com/aiassistant-help.gif" />
          </div>
          <p className='welcome-text'>Create your first agent to get started</p>
        </div>

        <div className='create-btn-box'>
          <button className='btn-style-new' onClick={handleCreateAgent}>
            Create Agent
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmptyAgentState;
